<template>
  <div class="row-settings" @click.stop>
    <div class="row-settings-field">
      <label>Count</label>
      <InputNumber
        :model-value="count"
        :min="1"
        :max="maxCount"
        showButtons
        buttonLayout="horizontal"
        incrementButtonIcon="pi pi-plus"
        decrementButtonIcon="pi pi-minus"
        class="row-count-input"
        @update:modelValue="(value) => $emit('update:count', value)"
      />
    </div>
    <div class="row-settings-field">
      <label>Duration (s)</label>
      <InputNumber
        :model-value="duration"
        :min="60"
        :max="180"
        class="row-duration-input"
        @update:modelValue="(value) => $emit('update:duration', value)"
      />
    </div>
  </div>
</template>

<script setup>
import InputNumber from "primevue/inputnumber";

// eslint-disable-next-line no-undef
defineProps({
  count: { type: Number, default: 1 },
  duration: { type: Number, default: 60 },
  maxCount: { type: Number, default: 5 },
});
// eslint-disable-next-line no-undef
defineEmits(["update:count", "update:duration"]);
</script>

<style scoped>
.row-settings {
  flex-basis: 100%;
  display: flex;
  gap: 1.25rem;
  margin-top: 0.5rem;
  padding-top: 0.6rem;
  border-top: 1px solid var(--surface-border);
  cursor: default;
}

.row-settings-field {
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.row-settings-field label {
  font-size: 0.75rem;
  font-weight: 600;
  color: var(--text-color-secondary);
}

.row-count-input {
  width: 8.5rem;
}

.row-count-input :deep(.p-inputnumber-input) {
  width: 3.5rem;
  text-align: center;
}

.row-duration-input {
  width: 3.5rem;
}
</style>
